import $ from 'jquery';

$(function() {
    var PenalitesManager = {
        Init: () => { 
        
        if (($("#drdViolations") == null) && ($("#drdPenalties") == null) && ($("#hdnViolatorType") == null)) {
            return;
        }

        $("#drdViolations").on("change", (function(e) {
            var csrf = $("[name='_token']").val();
            var option = $(this).val();
            var violatorType = $("#hdnViolatorType").val();

            if (option == -1) {
                $("#drdPenalties").find("option").each(function() {
                    $(this).remove();
                })
            }

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: "/api/lessors/violation/penalties/getLessorPenaltiesByViolation",
                type: 'POST',
                dataType: 'json',
                data: { "_token": "" + csrf + "", "violationID": option, "violator_type": violatorType },
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
                    $("#drdPenalties").fadeOut('fast');
                },
                success: function(result) {
                    var htmlData = "";
                    $("#drdPenalties").fadeIn('fast');

                    $.each(result, function(index, elem) {
                        htmlData += "<option value=\"" + elem.id + "\">" + elem.description + "</option>";
                        $("#drdPenalties").html(htmlData); 
                    });              
                }
            });
        }));

        if ($("#drdViolations").val() > "-1") {
            $("#drdViolations").change();
        }

        }
    }

    PenalitesManager.Init();
});